import axios from "./AxiosWrapper";
import config from "../config";

const SeatingMapService = {
  saveTicketMapping(
    ticketMappingData,
    seatingMapId,
    eventId,
    eventDateId,
    token
  ) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config(
            "API_URL"
          )}seatingmaps/ticketmapping/${eventId}/${eventDateId}/${seatingMapId}`,
          { ticketMapping: ticketMappingData },
          { params: { token } }
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(err => reject(err));
    });
  },
  get(eventId, seatingMapId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config("API_URL")}seatingmaps/${eventId}/${seatingMapId}`)
        .then(response => resolve(response.data))
        .catch(err => reject(err));
    });
  },
  getAll(eventId, eventDateId, orderId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config(
            "API_URL"
          )}seatingmaps/all/${eventId}/${eventDateId}/${orderId}`
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err));
    });
  },
  async getPublic(eventId, token, orderId) {
    const response = await axios.get(
      `${config("API_URL")}public/seating-map/${eventId}/${orderId}/${token}`
    );
    return response.data;
  }
};

export default SeatingMapService;
